// The active store an internal member is viewing. Scopes the store-specific modules (orders,
// clients, new order, payments, analytics) — the dashboard stays universal. Persisted per session.
import { create } from 'zustand';
import { safeGet, safeSet } from '../lib/storage.js';

const KEY = 'wholesale.activeStore';

export const useStoreContext = create((set, get) => ({
  activeStore: safeGet(KEY) || '', // '' = no store filter (non-staff)

  setActiveStore(code) {
    const v = code || '';
    safeSet(KEY, v);
    set({ activeStore: v });
  },

  // Reconcile the active store with the signed-in user's store access. Called once the user loads.
  // Only INTERNAL_STAFF use the live store toggle; reps + clients are scoped server-side by their
  // store access / company mapping, so they get no toggle ('').
  initForUser(user) {
    if (!user || user.role !== 'INTERNAL_STAFF') {
      set({ activeStore: '' });
      return;
    }
    const access = user.storeAccess;
    let s = get().activeStore;
    if (access === 'A') s = 'A';
    else if (access === 'B') s = 'B';
    else if (!['A', 'B'].includes(s)) s = 'A'; // BOTH, no valid prior choice
    safeSet(KEY, s);
    set({ activeStore: s });
  },
}));
